/**
 * @desc 导入sku信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/storageDamageMaster/importSkuInfoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
